import { motion } from 'framer-motion';
import React from 'react';

const FadeInDiv = props => {
  return <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, duration: 0.9 }} {...props} />;
};

export default FadeInDiv;
